define([
    "dojo/_base/declare",
    "csi",
    "csi/action/Controller",
    "csi/action/EmailController",
    "csi/comm/PostRequest",
    "csi/locale",
    "csi/reflection",
    "csi/resolver",
    "csi/utility/htmlUtility",
    "csi/widget/MessageDialog",
    "csi/xml"
], function(declare,csi,ActionController,EmailController,PostRequest,locale,reflection,resolver,{purifyForHtml},MessageDialog,xml) {

    const CONFIG = "centric://REFLECTION/INSTANCE/SourcingModule/Configuration";
    const configNode = reflection.getObject(CONFIG);
    const enableEmail = configNode.SupplierRequestEmailDataPackageLinkWhenIssued;

    return declare(enableEmail ? EmailController : ActionController, {

        /**
         * @override
         * Get initial values for Email form
         */
        getInitialValues() {
            const initialValues = this.inherited(arguments);
            const beginURL = window.location.origin + "/WebAccess/home.html#URL=";
            const endURL = "&Tab=Setup&Type=SupplierRequest";
            const cache = this.getCache();
            const supplierRequest = cache.getNode(this.m_urlNode);
            const subject = locale.resource("SupplierRequest_HasBeenIssued", [supplierRequest.$Name]);
            let body = `<br/><a href='${beginURL + supplierRequest.$URL + endURL}'>${supplierRequest.$Name}</a><br/>\n`;

            supplierRequest.LineItems.forEach(lineItemURL => {
                const lineItem = resolver.resolveNode(lineItemURL, true, cache);
                if (xml.isValidURL(lineItem.SRLineItemPackage)) {
                    body += `<br/><a href='${beginURL + lineItem.SRLineItemPackage}'>${lineItem.$Name}</a><br/>\n`;
                }
            });

            initialValues.subject = subject;
            initialValues.message = purifyForHtml(body + initialValues.message);
            initialValues.toUsers = supplierRequest.NotifiedUsers;

            return initialValues;
        },

        /**
         * @override
         *
         * If the Supplier Request Template has IsSupplierSpecific set to true
         * check to make sure all data packages and data package data sheets
         * against styles in the supplier request have ForProductSource set to empty
         * or the value matches the supplier in the Supplier Request
         */
        hasToConfirmAction: function() {

            var supplierRequest = this.getNode();
            var dataPackageTemplateURL = supplierRequest.SRDPTemplate;

            if (!dataPackageTemplateURL || dataPackageTemplateURL == csi.EMPTY_URL) {
                return false;
            }

            var dataPackageTemplate = this.getCache().getNode(dataPackageTemplateURL);
            this.supplierSpecific = dataPackageTemplate.IsSupplierSpecific;
            if (!dataPackageTemplate.IsSupplierSpecific){
                return false;
            }

            return this.hasToConfirm;
        },

        /**
         * @override
         *
         * Validate the Supplier Request
         */
        onPreActionDeferreds: function(dfds) {
            var request = new PostRequest("Sourcing", "ValidateSupplierRequest");
            request.addParameter(xml.PROP_URL, this.m_urlNode);

            const newDfd = request.go().then((response) => this.hasToConfirm = !response.getReturnValue());
            dfds.push(newDfd);
        },

        /**
         * @override
         */
        toWriter() {
            let call1 = this.m_writer.callMethod("Sourcing", "SupplierRequest_IssueRequest");
            call1.addParameter(xml.PROP_URL, xml.ATTR_REF, this.m_urlNode);

            if (!enableEmail) {
                return call1;
            }
            
            let call2 = this.m_writer.callMethod("Sourcing", "EmailDataPackagesForSR");
            call2.addParameter("SendTo", xml.ATTR_REFLIST, this._values.toUsers);
            call2.addParameter("CCTo", xml.ATTR_REFLIST, this._values.ccUsers);
            call2.addParameter("BCCTo", xml.ATTR_REFLIST, this._values.bccUsers);
            call2.addParameter("Subject", xml.ATTR_STRING, this._values.subject);
            call2.addParameter("Text", xml.ATTR_STRING, this.prepareMessageBody());
            call2.addParameter(xml.PROP_URL, xml.ATTR_REF, this.m_urlNode);

            return call2;
        },

        /**
         * @override
         *
         * Prompt confirmation with buttons “Ok” and “Cancel”.
         */
        confirmAction: function(params) {
            params = params || {};
            params.title = this.m_action.m_name;
            params.message = locale.resource("IssueRequestController_Warning");
            params.buttons = [MessageDialog.BUTTON_ISSUE, MessageDialog.BUTTON_CANCEL];
            this.inherited(arguments);
        },

        /**
         * @override
         *
         * Continue if confirmed
         */
        onConfirm: function(/*String*/key) {
            if (key == MessageDialog.BUTTON_CANCEL) {
                this.postProcess();
            } else {
                this.preProcess();
            }
        }

    });
});